import { fetchApi } from './api'

export const CANCEL_STRIPE_SUBSCRIPTION = 'CANCEL_STRIPE_SUBSCRIPTION'
export const CANCEL_STRIPE_SUBSCRIPTION_SUCCESS = 'CANCEL_STRIPE_SUBSCRIPTION_SUCCESS'
export const CANCEL_STRIPE_SUBSCRIPTION_ERROR = 'CANCEL_STRIPE_SUBSCRIPTION_ERROR'

export function cancelSubscription({ onSuccessCallback, onErrorCallback }) {
  return fetchApi({
    requestType: CANCEL_STRIPE_SUBSCRIPTION,
    successType: CANCEL_STRIPE_SUBSCRIPTION_SUCCESS,
    errorType: CANCEL_STRIPE_SUBSCRIPTION_ERROR,
    route: '/purchases/stripe/subscription/cancel',
    options: {
      method: 'PUT'
    },
    onSuccessCallback,
    onErrorCallback
  })
}
